import { forwardRef } from "react";
import MuiButton, { ButtonProps as MuiButtonProps } from "@mui/material/Button";

declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    default: true;
  }

  interface ButtonPropsVariantOverrides {
    cornerType: true;
  }
}

type ButtonCornerType = "default" | "rounded" | "square";

export interface ButtonProps extends MuiButtonProps {
  cornerType?: ButtonCornerType;
  dataDogIdentifier: string;
}

const cornerTypeSizeMap = {
  default: "0px",
  rounded: "48px",
  square: "4px"
};

const ButtonComponent = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ cornerType = "square", sx, dataDogIdentifier, ...props }, ref) => {
    return (
      <MuiButton
        ref={ref}
        sx={{ ...sx, borderRadius: cornerTypeSizeMap[cornerType] }}
        data-action-name={`${dataDogIdentifier} button`}
        {...props}
      />
    );
  }
);

ButtonComponent.displayName = "Button";

export default ButtonComponent;
